import { QUERY_PARAMS } from '@doda/common/src/constants/queryParams';

/**
 * 人気求人ランキングページのURLを生成する
 * @param queryKey 求人検索用クエリパラメータのキー
 * @param queryValue 求人検索用クエリパラメータの値
 * @returns 人気求人ランキングページのURL
 * キーと値を組み合わせて生成する。年収がキーの場合は上限指定なしのURLを返す
 */
export const createJobRankingUrl = (
  queryKey: string,
  queryValue: string
): string => {
  if (queryKey === QUERY_PARAMS.ha) {
    return `/DodaFront/View/JobContent/JobRanking/j_ha__${queryValue}%2C0/`;
  }
  return `/DodaFront/View/JobContent/JobRanking/j_${queryKey}__${queryValue}/`;
};
